import { environment } from '../../environments/environment';

export const Global = {
  BASE_API_URL: environment.apiUrl,
  LOGIN_BASE_API_URL: environment.loginApiUrl,
  MOCK_URL: environment.mockUrl,
  BASE_API_URL2: environment.apiUrl2,
};
